

import * as THREE from "three";
import * as ZapparThree from "@zappar/zappar-threejs";

let camera: ZapparThree.Camera;
let isFrontCamera = false;

export function initCamera() {
    camera = new ZapparThree.Camera();
    camera.backgroundTexture.encoding = THREE.sRGBEncoding;
    return camera;
}

export function flipCamera() {
    isFrontCamera = !isFrontCamera;
    console.log('isFrontCamera ' + isFrontCamera)
    camera?.start(isFrontCamera)
}
